export default __webpack_public_path__ + "static/media/Inspect it-Logo.030bc8ad.png";